const EmailSubscription = {

	ajaxUrl: null,

	form: null,

	fields: {
		action: {
			value: 'subscribe'
		},
		email: null,
		_wpnonce: null,
	},

	validateEmail: (email) => {
		return /\S+@\S+\.\S+/.test(email);
	},


	sendBackendRequest: () => {

		EmailSubscription.form.classList.add('loading')

		let formData = new FormData();

		for (const [fieldName, field] of Object.entries(EmailSubscription.fields)) {
			formData.append(fieldName, field.value);
		}


		fetch(EmailSubscription.ajaxUrl, {
			method: 'POST',
			body: formData,
		}).then((response) => {
			return response.json();
		}).then((response) => {
			console.log('response', response);
			if (response.success && response.success === true) {
				EmailSubscription.showSuccessMessage()
			} else {
				EmailSubscription.showErrorMessage()
			}

		})
			.catch((error) => {
				console.error(error);
			})
			.finally(() => {
				EmailSubscription.form.classList.remove('loading')
			});

	},


	subscribe: (event) => {
		event.preventDefault()

		EmailSubscription.form = event.target

		EmailSubscription.fields.email = EmailSubscription.form.querySelector('input[name="email"]')
		EmailSubscription.fields._wpnonce = EmailSubscription.form.querySelector('input[name="_wpnonce"]')


		EmailSubscription.fields.email.classList.remove('invalid')
		if (EmailSubscription.validateEmail(EmailSubscription.fields.email.value) !== true) {
			EmailSubscription.fields.email.classList.add('invalid')
			return false;
		}

		EmailSubscription.sendBackendRequest()

		EmailSubscription.form.reset()
	},


	showSuccessMessage: () => {

		let successMessage = EmailSubscription.form.querySelector('.success-message')

		successMessage.classList.add('active')
		setTimeout(() => {
			successMessage.classList.remove('active')
		}, 3 * 1000);
	},

	showErrorMessage: () => {

		let errorMessage = EmailSubscription.form.querySelector('.error-message')

		errorMessage.classList.add('active')
		setTimeout(() => {
			errorMessage.classList.remove('active')
		}, 3 * 1000);
	},
}